import { render, staticRenderFns } from "./index.vue?vue&type=template&id=395d299a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395d299a')) {
      api.createRecord('395d299a', component.options)
    } else {
      api.reload('395d299a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=395d299a&", function () {
      api.rerender('395d299a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-locales/index.vue"
export default component.exports